import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Mobileprowessuk({ handleShow }) {
  return (
    <section className="mobile_prowessuk p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={3}
            lg={3}
            xl={4}
            xxl={4}
            className="order-2 order-md-1"
          >
            <div className="prowess_image">
              <StaticImage
                src="../../../images/location_new/uk-mobile/mobile_prowess.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={720}
                height={1222}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={8}
            xxl={8}
            className="order-1 order-md-2"
          >
            <h2>
              Our <span>Mobile App Development</span> Prowess
            </h2>
            <p>
              Our app development USP lies in our advanced integration of novel
              technologies and data analytics. We use predictive analytics and
              robust development frameworks to build high-performance, scalable
              applications. Our custom solutions are designed to optimise user
              engagement and deliver precise, data-driven results tailored to
              your business needs.
            </p>
            <Row className="mt-3 mt-md-4">
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={6}
                xxl={6}
                className="mb-3 mb-md-4"
              >
                <div className="prowess_box">
                  <div className="prowess_flex">
                    <div className="num">01</div>
                    <div className="prowess_head">
                      <h5>Top-Level UK App Developers</h5>
                    </div>
                  </div>
                  <p>
                    Our expert team delivers tailored app solutions with deep
                    technical expertise.
                  </p>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={6}
                xxl={6}
                className="mb-3 mb-md-4"
              >
                <div className="prowess_box">
                  <div className="prowess_flex">
                    <div className="num">02</div>
                    <div className="prowess_head">
                      <h5>24/7 Availability</h5>
                    </div>
                  </div>
                  <p>
                    We provide round-the-clock support for uninterrupted app
                    performance.
                  </p>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={6}
                xxl={6}
                className="mb-3 mb-md-0"
              >
                <div className="prowess_box">
                  <div className="prowess_flex">
                    <div className="num">03</div>
                    <div className="prowess_head">
                      <h5>Fast Turnaround</h5>
                    </div>
                  </div>
                  <p>
                    Efficient processes and a dedicated team ensure rapid
                    delivery of high-quality apps.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                <div className="prowess_box">
                  <div className="prowess_flex">
                    <div className="num">04</div>
                    <div className="prowess_head">
                      <h5>Customisable Solutions</h5>
                    </div>
                  </div>
                  <p>
                    Our apps are designed to adapt to new business needs and
                    user demands.
                  </p>
                </div>
              </Col>
            </Row>
            <div className="btn mt-3 mt-md-5">
              <button
                onClick={handleShow}
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Schedule a Meeting
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Mobileprowessuk;
